__turbopack_context__.v({
  "className": "fontroboto_d23aa6d2-module__I0LhPW__className",
  "variable": "fontroboto_d23aa6d2-module__I0LhPW__variable",
});
